<template>
	<div
		class="g-block-title-heading g-block-title-padding"
		:class="[
			`g-block-title-heading--level-${level}`,
			{
				'g-block-title-heading--edit': editable,
				'is-active': editable && active,
				'g-block-title-heading--h5': h5,
				'g-block-title-padding--h5': h5,
			},
		]"
		@click="onWrapClick"
	>
		<RichTextEditable
			v-if="editable"
			class="g-block-title-heading__text"
			fit-content
			:style="{ color: themeColor }"
			:model-value="data.content"
			placeholder="请输入标题"
			@update:model-value="onContentUpdate"
			@focus="onWrapClick"
		/>
		<div
			v-else
			class="g-block-title-heading__text"
			:style="{ color: themeColor }"
			v-html="data.content || ''"
		></div>
	</div>
</template>

<script>
	import RichTextEditable from '../../../components/RichTextEditable.vue';
	import { getHeadingLevel, singleTitleMixin } from '../shared/singleTitleMixin.js';

	export default {
		name: 'GBlockTitleHeading',
		components: { RichTextEditable },
		mixins: [singleTitleMixin],
		computed: {
			level() {
				return getHeadingLevel(this.data);
			},
		},
	};
</script>

<style scoped lang="less">
	.g-block-title-heading {
		text-align: left;

		&--edit {
			border: 1px solid transparent;
			border-radius: 4px;
			transition: border-color 0.2s, box-shadow 0.2s;
			cursor: pointer;

			&.is-active {
				border-color: #285af9;
				box-shadow: 0 0 0 1px rgba(40, 90, 249, 0.15);
			}
		}
	}

	.g-block-title-heading__text {
		display: inline-flex;
		width: 100%;
		font-weight: 700;
		line-height: 1.3;
		padding: 0;
		font-family: inherit;
		word-break: break-word;
		white-space: pre-wrap;
		color: inherit;

		:deep(.g-rich-text-editable) {
			display: inline-flex;
			width: auto;
			max-width: 100%;
			color: inherit;
		}

		:deep(.g-rich-text-editable__content) {
			line-height: 1.3;
			min-height: unset;
			padding: 0;
			color: inherit;
			font-weight: 700;
		}

		:deep(span),
		:deep(font),
		:deep(p),
		:deep(div) {
			margin: 0;
			padding: 0;
			color: inherit;
			font-weight: inherit;
		}
	}

	.g-block-title-heading--level-1 .g-block-title-heading__text {
		font-size: 32px;
	}

	.g-block-title-heading--level-2 .g-block-title-heading__text {
		font-size: 28px;
	}

	.g-block-title-heading--level-3 .g-block-title-heading__text {
		font-size: 24px;
	}

	.g-block-title-heading--level-4 .g-block-title-heading__text {
		font-size: 20px;
	}

	.g-block-title-heading--level-5 .g-block-title-heading__text {
		font-size: 18px;
	}

	.g-block-title-heading--level-6 .g-block-title-heading__text {
		font-size: 16px;
	}

	.g-block-title-heading--h5 {
		&.g-block-title-heading--level-1 .g-block-title-heading__text {
			font-size: 0.64rem;
		}

		&.g-block-title-heading--level-2 .g-block-title-heading__text {
			font-size: 0.56rem;
		}

		&.g-block-title-heading--level-3 .g-block-title-heading__text {
			font-size: 0.48rem;
		}

		&.g-block-title-heading--level-4 .g-block-title-heading__text {
			font-size: 0.4rem;
		}

		&.g-block-title-heading--level-5 .g-block-title-heading__text {
			font-size: 0.36rem;
		}

		&.g-block-title-heading--level-6 .g-block-title-heading__text {
			font-size: 0.32rem;
		}
	}
</style>
